import { Grid } from '@material-ui/core';

export const Logo = () => {
  return (
    <img
      alt="FleetGenix"
      src="/images/repair_on_demand_black.png"
      width="370"
    />
  );
};

export const LogoIcon = () => {
  return (
    <img
      alt="FleetGenix"
      src="/images/color_light_small_square.png"
      height="40"
    />
  );
};

export const LogoHorizontalDark = () => {
  return (
    <img
      alt="FleetGenix"
      src="/images/repair_on_demand_logo.png"
      height="50"
    />
  );
};

export const LogoHorizontal = () => {
  return (
    <img
      alt="FleetGenix"
      src="/images/repair_on_demand_black.png"
      height="50"
    />
  );
};

export const LogoHorizontalSmall = () => {
  return (
    <img
      alt="FleetGenix"
      src="/images/color_light.png"
      height="25"
    />
  );
};

export const ManheimLogoSquare = () => {
  return (
    <img
      alt="ManheimLogoSquare"
      src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/1743241/manheimLogo.svg"
      height="40"
    />
  );
};

export const ManheimRepairifyLogo = () => {
  return (
    <Grid container 
      alignItems="center"
      justifyContent="flex-start"
      spacing={1}
    >
      <Grid item>
        <img
          alt="ManheimLogo"
          src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/1743241/manheimLogo.svg"
          height="40"
        />
      </Grid>
      <Grid item>
        <img
          alt="ManheimLogo"
          src="/images/driven.png"
          height="10"
        />
      </Grid>
    </Grid>
  );
};

export const CarvanaRepairifyLogo = () => {
  return (
    <Grid container 
      alignItems="center"
      justifyContent="flex-start"
      spacing={1}
    >
      <Grid item>
        <img
          alt="CarvanaLogo"
          src="/images/carvana_logo.svg"
          height="35"
        />
      </Grid>
      <Grid item>
        <img
          alt="CarvanaLogo"
          src="/images/driven.png"
          height="10"
        />
      </Grid>
    </Grid>
  );
};

export const RepairOnDemandLogo = () => {
  return (
    <Grid container 
      alignItems="center"
      justifyContent="flex-start"
      spacing={1}
    >
      <Grid item>
        <img
          alt="CarvanaLogo"
          src="/images/repair_on_demand_black.png"
          height="35"
        />
      </Grid>
      <Grid item>
        <img
          alt="CarvanaLogo"
          src="/images/driven.png"
          height="10"
        />
      </Grid>
    </Grid>
  );
};
